import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { environment } from '../../../../environments/environment';

@Injectable({
	providedIn: 'root'
})
export class ApiService {
	constructor(private readonly http: HttpClient) {}

	/**
	 * @description set headers for the api calls with token.
	 */
	private getHeaderWithToken() {
		return {
			Authorization: `Bearer ${sessionStorage.getItem('auth_token')}`,
			'Ocp-Apim-Subscription-Key': environment.subscriptionKey,
			AuthenticationType: environment.authenticationType
		};
	}

	/**
   * @description generate the params needed for the api call to banner api.
   * @param email email of the student logged in.
   */
	private getParamsForBanner(email) {
		return new HttpParams().set('studentEmail', email);
	}

	/**
	 * @description Execute the get method.
	 * @param apiUrl url of the api to be called.
   * @param email email of the student.
	 * @param successCallback succes callback for the api call function.
	 * @param failureCallback failure callback for the api call function.
	 */
	public doGet(apiUrl, email, successCallback, failureCallback) {
		const _headers = this.getHeaderWithToken();
		const _params = this.getParamsForBanner(email);
		const options = {
			headers: _headers,
			params: _params
		};
		this.http.get(apiUrl, options).subscribe(
			(response) => {
				successCallback(response);
			},
			(error) => {
				failureCallback(error);
			}
		);
	}

	/**
     * @desc Http service call for POST method
     * @param {string} apiUrl api url
     * @param {Object} data the data to be posted to the api
     * @param {function} successCallback success callback
     * @param {function} failureCallback failure callback
     **/
	public doPost(apiUrl, data, successCallback, failureCallback) {
		this.http.post(apiUrl, data).subscribe(
			(response) => {
				successCallback(response);
			},
			(error) => {
				failureCallback(error);
			}
		);
	}
}
